export default "__VITE_ASSET__TVBJU9bU__"